// Name, room size, bedding, additional bedding, max capacity, approve, expand. Deal option rows reuse it so
// allocation sits under additional bedding and occupancy under max capacity.
export const ROOM_CARD_GRID_TEMPLATE_COLUMNS = 'minmax(200px, 1fr) 90px 130px 130px 110px 120px 56px';

export const DEAL_OPTION_NAME_COLUMN = '1 / 4';
export const DEAL_OPTION_ALLOCATION_COLUMN = '4';
export const DEAL_OPTION_OCCUPANCY_COLUMN = '5';
